import { ActivityIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RouteLink } from "../../app/route-link";
import type { KindTabProps } from "../../kinds/tabs";
import { EmptyState } from "../../ui/empty-state";
import { routes } from "../context";
import { RunsList } from "./runs-page";

/** The "Runs" tab of an agent's spec page: the project's runs of that agent. */
export function AgentRunsTab({ workspace, specRef }: KindTabProps) {
  const { t } = useTranslation();
  const project = specRef.project;
  if (!project) {
    return (
      <EmptyState icon={ActivityIcon} title={t("runs.empty.title")} text={t("runs.empty.text")} />
    );
  }
  return (
    <div className="space-y-3">
      <RouteLink to={routes.runs(workspace, project, { agent: specRef.name })} className="text-sm">
        {t("runs.openAll")}
      </RouteLink>
      <RunsList workspace={workspace} project={project} filters={{ agent: specRef.name }} />
    </div>
  );
}
